import { useState, useEffect } from 'react';

import { Typography, Button, Modal, Radio, Select, Input, Form, Space, message, InputNumber } from 'antd';

import { getError, getMDMTransportClient } from '../../clientUtils';

const { Text } = Typography;

const modeOptions = [
  { label: 'Road', value: 'ROAD' }
  // { label: "Rail", value: "RAIL" },
  // { label: "Air", value: "AIR" },
  // { label: "Ship", value: "SHIP" },
];

const EWayBillDetailsModal = ({ isOpen, onOk, onCancel, loading, hasDistanceField, transportDetails }) => {
  const [eWayBillGenerateAction, setEWayBillGenerateAction] = useState('PARTA');
  const [transporters, setTransporters] = useState([]);
  const [transporterNameId, setTransporterNameId] = useState('');
  const [GSTNumbers, setGSTNumbers] = useState([]);
  const [form] = Form.useForm();
  const transportId = Form.useWatch('transportId', form);
  const transportName = Form.useWatch('transportName', form);
  const distance = Form.useWatch('distance', form);
  const transportationMode = Form.useWatch('transportationMode', form);
  const vehicleNumber = Form.useWatch('vehicleNumber', form);

  const transporterOptions = transporters?.map((transporter) => ({
    label: transporter?.registered_transport_name,
    value: transporter?.id
  }));

  const GSTNumbersOptions = GSTNumbers?.map((GSTNumber) => ({
    label: `${GSTNumber?.gst_number} - ${GSTNumber?.transport_state}`,
    value: GSTNumber?.id
  }));

  useEffect(() => {
    const getTransporters = async () => {
      try {
        const response = await getMDMTransportClient().transportGet();
        setTransporters(response?.data?.data);
      } catch (error) {
        message.error(getError(error));
      }
    };
    getTransporters();
  }, []);

  useEffect(() => {
    const getGSTNumbers = async () => {
      try {
        const response = await getMDMTransportClient().transportDocDetailsGet(transporterNameId);
        setGSTNumbers(response?.data?.data);
      } catch (error) {
        message.error(getError(error));
      }
    };
    transporterNameId && getGSTNumbers();
  }, [transporterNameId]);

  useEffect(() => {
    if (transportDetails?.transporter_id) {
      setTransporterNameId(transportDetails?.transporter_id);
    }
    if (transportDetails && Object.keys(transportDetails).length > 0) {
      setEWayBillGenerateAction('PARTAB');
      form.setFieldsValue({ eWayBillGenerateAction: 'PARTAB' });
    }
  }, [transportDetails, form]);

  const onChange = ({ eWayBillGenerateAction, transportName }) => {
    eWayBillGenerateAction && setEWayBillGenerateAction(eWayBillGenerateAction);
    transportName && setTransporterNameId(transportName);
  };
  const onFinish = (values) => {
    let transportName = transporters?.find(
      (transporter) => transporter?.id == values?.transportName
    )?.registered_transport_name;

    if (!transportName && values?.transportName) {
      transportName = values.transportName;
    }

    // Helper to find GST record
    let gstRecord = GSTNumbers?.find((numbers) => numbers?.id == values?.transportId);

    // Fallback: try finding by gst_number string
    if (!gstRecord) {
      gstRecord = GSTNumbers?.find((numbers) => numbers?.gst_number == values?.transportId);
    }

    let transportId = gstRecord?.transport_ref_id;
    let transportDocNumber = gstRecord?.gst_number;

    // Fallback if gstRecord lookup failed
    if (!transportDocNumber && values?.transportId) {
      transportDocNumber = values.transportId;
    }
    // Note: We might miss transport_ref_id here if lookup fails, but at least we send the Doc Number.

    console.log('Derived values:', { transportName, transportId, transportDocNumber });

    if (!transportName || !transportId || !transportDocNumber) {
      console.warn('Some transport details could not be derived from lookups.');
    }

    onOk({ ...values, transportName, transportId, transportDocNumber });
  };

  const onFinishFailed = (errorInfo) => {
    // TODO: add indicator for user
    console.log('Failed:', errorInfo);
  };

  const isDisabled = () => {
    if (eWayBillGenerateAction === 'PARTA' && !hasDistanceField) {
      return transportId && transportName;
    }
    if (eWayBillGenerateAction === 'PARTA' && hasDistanceField) {
      return transportId && transportName && distance;
    }
    if (eWayBillGenerateAction === 'PARTAB' && !hasDistanceField) {
      return transportId && transportName && transportationMode && vehicleNumber;
    }
    if (eWayBillGenerateAction === 'PARTAB' && hasDistanceField) {
      return transportId && transportName && distance && transportationMode && vehicleNumber;
    }
  };

  const isTransporterPrefilled = transportDetails?.transporter_id && transportDetails?.transporter_gstin;

  const items = {
    PARTA: [
      {
        name: 'transportName',
        label: 'Transporter Name',
        input: <Select disabled={isTransporterPrefilled} options={transporterOptions} />
      },
      {
        name: 'transportId',
        label: 'GST No.',
        input: <Select disabled={isTransporterPrefilled || !transporterNameId} options={GSTNumbersOptions} />
      },
      ...(hasDistanceField
        ? [
          {
            name: 'distance',
            label: 'Distance',
            input: <InputNumber addonAfter="Kms" className="w-100" />
          }
        ]
        : [])
    ],
    PARTAB: [
      {
        name: 'transportName',
        label: 'Transporter Name',
        input: <Select disabled={isTransporterPrefilled} options={transporterOptions} />
      },
      {
        name: 'transportId',
        label: 'GST No.',
        input: <Select disabled={isTransporterPrefilled || !transporterNameId} options={GSTNumbersOptions} />
      },
      {
        name: 'transportationMode',
        label: 'Transporter Mode',
        input: <Select options={modeOptions} />
      },
      {
        name: 'vehicleNumber',
        label: 'Vehicle No.',
        input: <Input />
      },
      ...(hasDistanceField
        ? [
          {
            name: 'distance',
            label: 'Distance',
            input: <InputNumber className="w-100" />
          }
        ]
        : [])
      // {
      //   name: "transportDocNumber",
      //   label: "Transporter Doc No.",
      //   input: <Input />,
      // },
      // {
      //   name: "vehicleType",
      //   label: "Vehicle Type",
      //   input: <Input />,
      // },
    ]
  };

  return (
    <Modal className="e-way-bill-modal" footer={[]} onCancel={onCancel} open={isOpen} title="E-Way Bill Details">
      <Form
        autoComplete="off"
        colon={false}
        form={form}
        initialValues={{
          eWayBillGenerateAction: 'PARTA',
          ...(transportDetails?.transport_mode ? { transportationMode: transportDetails?.transport_mode } : { transportationMode: 'ROAD' }),
          ...(transportDetails?.transporter_id && { transportName: transportDetails?.transporter_id }),
          ...(transportDetails?.transporter_gstin && { transportId: transportDetails?.transporter_gstin })
        }}
        labelCol={{
          span: 8
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onChange}
        wrapperCol={{
          span: 16
        }}>
        <Text>Please select part to generate</Text>
        <Form.Item
          name="eWayBillGenerateAction"
          rules={[
            {
              required: true,
              message: 'Please select part to generate'
            }
          ]}>
          <Radio.Group value={eWayBillGenerateAction}>
            <Radio value="PARTA">Part A</Radio>
            <Radio value="PARTAB">Part A & Part B</Radio>
          </Radio.Group>
        </Form.Item>
        {items?.[eWayBillGenerateAction]?.map((item) => (
          <Form.Item
            label={item?.label}
            name={item?.name}
            rules={[
              {
                required: true,
                message: 'This Field is mandatory!'
              }
            ]}>
            {item?.input}
          </Form.Item>
        ))}

        <Form.Item className="modal-btns">
          <Space align="end">
            <Button onClick={onCancel}>Cancel</Button>
            <Button disabled={!isDisabled()} htmlType="submit" loading={loading} type="primary">
              Generate
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EWayBillDetailsModal;
